import { createSelector } from 'reselect';
import { getFAIEnabled } from './getFAIEnabled';
import { getIsLatestActivitySetup } from './getIsLatestActivitySetup';
import { getFAIApproved } from './getFAIApproved';
import { getFAIHasActiveInspection } from './getFAIHasActiveInspection';
import { getCurrentOperator } from './getCurrentOperator';

const getCanRequestFAI = createSelector(
  [
    getFAIEnabled,
    getIsLatestActivitySetup,
    getFAIApproved,
    getFAIHasActiveInspection,
    getCurrentOperator,
  ],
  (faiEnabled, isSetup, approved, hasActiveInspection, operator) => {
    return !!(
      faiEnabled &&
      isSetup &&
      !approved &&
      !hasActiveInspection &&
      operator
    );
  }
);

export { getCanRequestFAI };
